import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestService } from '../shared/request.service';
import { ConstantValues } from '../../common/constant-values';
import { OtpRequest, OtpVerify, Pensioner, PensionerDetailDto } from '../../models/pensionermanagement/Pensioner';
import { BaseResponse, PageInfo } from '../../models/commonResponse';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { PensionerByPPANo } from '../../models/pensionermanagement/PensionerByPPANo';
import { PensionList } from '../../models/pensionermanagement/Pension';
import { PensionBatchFile } from '../../models/pensionermanagement/importedpensionfile/PensionBatchFile';
import { BatchRecordPensionerDetail } from '../../models/pensionermanagement/importedpensionfile/BatchRecordPensionerDetail';
import { PensionTypeListResponse, RelationAndReligionListResponse } from '../../models/data-store.model';
import { SelectOption } from '../../models/adminmanagement/AdminRole';
import { RejectPension } from '../../models/verification/PensionDetailDto.model';
import { UserAction } from '../../models/verification/PeymeVerification.model';

@Injectable({
  providedIn: 'root'
})
export class PensionermanagementService {

  constructor(private http: HttpClient, private requestService: RequestService) { }

  //#region pension changes log
  private loadChangesSource = new Subject<{userLevel?: string, hardRefresh?: boolean, pensionId: string, parentType: string}>();
  loadChanges$ = this.loadChangesSource.asObservable();

  triggerLoadChanges(params: {userLevel?: string, hardRefresh?: boolean, pensionId: string, parentType: string}) {
    this.loadChangesSource.next(params);
  }
  //#endregion

  //#region paymeuser list
  private loadPaymeUserListSource = new BehaviorSubject<void>(undefined);
  loadPaymeUserList$ = this.loadPaymeUserListSource.asObservable();

  triggerLoadPaymeUserList() { this.loadPaymeUserListSource.next(); }
  //#endregion

  //#region  preparation
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json',
      // "Authorization": "Bearer " + this.
    })
  }

  // get header() {
  //   return {
  //     'Content-Type': 'application/json',
  //     'Accept': '*/*',
  //     'Authorization': `Bearer ${this.currentToken || ''}`
  //   };
  // }

  // get currentToken(): string | null {
  //   return localStorage.getItem();
  // }

  baseAPIUrl = environment.baseAPIUrl + "/" + environment.apiVer;
  middleWare = environment.middleWareAPIUrl + "/" + environment.apiVer;
  showMsg = '';
  showLV2Msg = '';
  showPDMsg = '';
  //#endregion

  setUpPensioner(msgData: PensionerDetailDto) {
    const request = this.requestService.createBaseRequest(msgData.Id ? ConstantValues.UPDATE_PENSIONER : ConstantValues.CREATE_PENSIONER, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `pensioners/${msgData.Id ? 'update' : 'create'}`, request, this.httpOptions
    );
  }

  updatePaymeUser(msgData: any) {
    const request = this.requestService.createBaseRequest(ConstantValues.UPDATE_PAYMEUSER, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `pensioners/updatepaymeuser`, msgData, this.httpOptions
    );
  }

  // approveOrRejectPaymeUser(msgData: any) {
  //   const request = this.requestService.createBaseRequest(ConstantValues.UPDATE_PAYMEUSER_STATUS, msgData);

  //   return this.http.post<BaseResponse<any>>(
  //     this.baseAPIUrl + `pensioners/updatepaymeuserstatus`, msgData, this.httpOptions
  //   );
  // }

  approveOrRejectPaymeUser(action: string, payload: any) {
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensions/${action}`, payload, this.httpOptions);
  }

  inactivePaymeUser(payload: any) {
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensions/inactive`, payload, this.httpOptions);
  }

  updatePension(msgData: any) {
    const request = this.requestService.createBaseRequest(ConstantValues.UPDATE_PENSION, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `pensioners/updatepension`, msgData, this.httpOptions
    );
  }

  getPensionTypeOptions():Observable<BaseResponse<PensionTypeListResponse>>{
      const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONTYPE_OPTIONS, {});
  
      return this.http.get<BaseResponse<PensionTypeListResponse>>(
        this.baseAPIUrl + `pensions/pensiontype`, this.httpOptions
      );
  }

  getDeceasedPensionList(model: any):Observable<BaseResponse<PensionTypeListResponse>>{
      const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONTYPE_OPTIONS, {});
  
      return this.http.post<BaseResponse<PensionTypeListResponse>>(
        this.baseAPIUrl + `pensions/deceaseduser`, model, this.httpOptions
      );
  }

  getDeceasedDetail(model: any):Observable<BaseResponse<PensionTypeListResponse>>{
      const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONTYPE_OPTIONS, {});
  
      return this.http.post<BaseResponse<PensionTypeListResponse>>(
        this.baseAPIUrl + `pensions/deceasedview`, model, this.httpOptions
      );
  }

  getRelationToNRCOptions():Observable<BaseResponse<RelationAndReligionListResponse>> {
    const request = this.requestService.createBaseRequest(ConstantValues.GET_RELATIONTONRC_OPTIONS, {});
    
        // return this.http.post<BaseResponse<RelationAndReligionListResponse>>(
        //   this.baseAPIUrl + `pensioners/relationtonrc`, request, this.httpOptions
        // );
         return this.http.get<BaseResponse<RelationAndReligionListResponse>>(
          this.baseAPIUrl + `pensioners/relationtonrc`, this.httpOptions
        );
  }
  
  approveOrRejectPension(msgData: any) {
    const request = this.requestService.createBaseRequest(ConstantValues.UPDATE_PENSION_STATUS, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `pensioners/updatepensionstatus`, request, this.httpOptions
    );
  }

  
  approveOrRejectPensionL1(msgData: any, routeName:string) {
    const request = this.requestService.createBaseRequest(ConstantValues.UPDATE_PENSION_STATUS, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `pensions/${routeName}`, msgData, this.httpOptions
    );
  }

  getPensionImportedList(msgData: any): any {
    const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONIMPORTED_LIST, msgData)
    return this.http.post<BaseResponse<{ PageInfo: PageInfo, Pensioners: Pensioner[] }>>(this.baseAPIUrl + `pensioners/pensionimportedlist`, request, this.httpOptions);
  }

  getPensionImportedList2(msgData: any): any {
    const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONIMPORTED_LIST, msgData)
    return this.http.post<BaseResponse<{ PageInfo: PageInfo, Pensioners: Pensioner[] }>>(this.baseAPIUrl + `pensions/importedlist`, msgData, this.httpOptions);
  }

  getPensionerList(msgData: any): any {
    const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONER_LIST, msgData)
    return this.http.post<BaseResponse<{ PageInfo: PageInfo, Pensioners: Pensioner[] }>>(this.baseAPIUrl + `pensioners/list`, msgData, this.httpOptions);
  }

  getPendingPaymeUserRegistrationList(msgData: any): any {
    const request = this.requestService.createBaseRequest(ConstantValues.GET_PENDING_PAYMEUSER_REGISTRATION, msgData);
    
    return this.http.get<BaseResponse<any>>(this.baseAPIUrl + `paymeusers/pendinglist?pageSize=` + msgData.PageSize  + '&currentPage=' + msgData.CurrentPageNumber, this.httpOptions);
  }

  getDashboardData() {
    const msgData = {
      ReqDate: ''
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_DASHBOARD_DATA, msgData)
    return this.http.get<BaseResponse<any>>(this.baseAPIUrl + 'adminusers/dashboarddata?ReqDate=0/0/0', this.httpOptions);
  }

  getLineChartData() {
    const msgData = {
      ReqDate: ''
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_DASHBOARD_DATA, msgData)
    return this.http.get<BaseResponse<any>>(this.baseAPIUrl + 'adminusers/newpaymeuserfordashboard', this.httpOptions);
  }

  getDashboardCashoutChartData() {
    const msgData = {
      ReqDate: ''
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_DASHBOARD_DATA, msgData)
    return this.http.get<BaseResponse<any>>(this.baseAPIUrl + 'adminusers/cashoutfordashboard', this.httpOptions);
  }

  getPensionList(msgData: any): any {
    // const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSION_LIST, msgData)
    return this.http.post<BaseResponse<{ PageInfo: PageInfo, Pensions: PensionList[] }>>(this.baseAPIUrl + `pensioners/pensionlist`, msgData, this.httpOptions);
  }


  getAbnormalPensionerList(msgData: any): any {
    const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONER_LIST_BYFILTER, msgData)
    return this.http.post<BaseResponse<{ PageInfo: PageInfo, Pensioners: Pensioner[] }>>(this.baseAPIUrl + `pensioners/listbyabnormalfilter`, request, this.httpOptions);
  }

  getPensionerRegistrationList(msgData: any): any {
    // const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONERREGISTRATION_LIST, msgData)
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioners/registrationlist`, msgData, this.httpOptions);
  }

  getRejectedPensionerList(msgData: any): any {
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioners/rejectedlistforportal`, msgData, this.httpOptions);
  }

  getVerifiedPensionerList(msgData: any): any {
    // const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONERREGISTRATION_LIST, msgData)
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioners/verifiedlist`, msgData, this.httpOptions);
  }

  paymeUserInactive(msgData: any): any {
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensions/inactive`, msgData, this.httpOptions);
  }

  getPensionerVerificationExpire(msgData: any): any {
    // const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONERREGISTRATION_LIST, msgData)
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioners/verificationexpire`, msgData, this.httpOptions);
  }

  getVerificationExpiredDetail(msgData: any, ): any {
    // const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONERREGISTRATION_LIST, msgData)
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioners/verificationexpiredetail`, msgData, this.httpOptions);
  }

  getPensionBatchFileList(msgData: any): any {
    const request = this.requestService.createBaseRequest(ConstantValues.GET_BATCHFILE_LIST, msgData)
    return this.http.post<BaseResponse<{ PageInfo: PageInfo, BatchFiles: PensionBatchFile[] }>>(this.baseAPIUrl + `pensions/batchfilelist`, msgData, this.httpOptions);
  }

  getBatchFileRecordPensionList(msgData: any): any {
    const request = this.requestService.createBaseRequest(ConstantValues.GET_BATCHFILE_DETAIL, msgData)
    return this.http.post<BaseResponse<{ PageInfo: PageInfo, BatchRecordPensions: BatchRecordPensionerDetail[] }>>(this.baseAPIUrl + `pensions/batchfiledetails`, msgData, this.httpOptions);
  }


  getIPensionerDetail(pensionerId: string) {
    const msgData = {
      PensionerId: pensionerId
    }

    // const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONER_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioners/detail`, msgData, this.httpOptions);
  }

  getPensionImportedDetail(pensionerId: string) {
    const msgData = {
      PensionImportedId: pensionerId
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONIMPORTED_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensions/importeddetails`, msgData, this.httpOptions);
    // return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `/pensioners/pensionimporteddetail`, request, this.httpOptions);
  }

  getIPensionerRegistrationDetail(pensionerId: string, status: string): Observable<any> {
    const msgData = {
      PensionerRegistrationId: pensionerId,
      FilterStatus: status
    };

    const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONERREGISTRATION_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensioners/registrationdetail`, msgData, this.httpOptions);
  }
  getMinistryListOptions(pensionGroup: string):Observable<BaseResponse<{Ministries: SelectOption[]}>> {
    const msgData = {
      PensionGroupId: pensionGroup
    };
    const request = this.requestService.createBaseRequest(ConstantValues.GET_MINISTRY_LIST_OPTIONS, msgData);

    return this.http.post<BaseResponse<{Ministries: SelectOption[]}>>(
      this.baseAPIUrl + `ministries/ministryoptions`, msgData, this.httpOptions
    );
  }  
  getDepartmentListOptions(pensionGroup: string, ministryId: string):Observable<BaseResponse<{Departments: SelectOption[]}>> {
    
    const msgData = {
      PensionGroup: pensionGroup,
      MinistryId: ministryId,
    };
    const request = this.requestService.createBaseRequest(ConstantValues.GET_DEPARTMENT_LIST_OPTIONS, msgData);

    return this.http.post<BaseResponse<{Departments: SelectOption[]}>>(
      this.baseAPIUrl + `departments/departmentoptions`, msgData, this.httpOptions
    );
  }
  

  getPaymeUserChangeDetails(paymeUserId: string, userLevel: string): Observable<any> {
    const msgData = {
      PaymeUserId: paymeUserId,
      UserLevel: userLevel
    };

    const request = this.requestService.createBaseRequest(ConstantValues.GET_PAYMEUSER_CHANGE_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `/paymeUsers/changedetails`, msgData, this.httpOptions);
  }

  getDataComparison(pensionId: string): Observable<any> {
    const msgData = {
      PensionId: pensionId
    };

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensions/getdatacomparison`, msgData, this.httpOptions);
  }

  getPensionChangeDetails(pensionId: string, userLevel: string, parentType: string): Observable<any> {
    const msgData = {
      Id: pensionId,
      UserLevel: userLevel
    };

    const request = this.requestService.createBaseRequest(parentType == ConstantValues.StaticValue.PayemeUser
      ? ConstantValues.GET_PAYMEUSER_CHANGE_DETAIL
      : ConstantValues.GET_PENSION_CHANGE_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `${parentType == ConstantValues.StaticValue.PayemeUser? 'paymeusers' : 'pensions'}/changedetails`, msgData, this.httpOptions);
  }

  retrieveImageFile(imageUrl: string): Observable<BaseResponse<{ImageFile: string}>> {
    const msgData = {
      ImageUrl: imageUrl
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_IMAGEFILE, msgData);
    return this.http.post<BaseResponse<{ImageFile: string}>>(this.baseAPIUrl + `pensioners/retrieveimage`, msgData, this.httpOptions);
  }

  getPensionDetail(pensionId: string, filterStatus: string): Observable<BaseResponse<{Pension: RejectPension}>> {
    const msgData = {
      PensionId: pensionId,
      FilterStatus: filterStatus
    }

    // const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSION_DETAIL, msgData);

    return this.http.post<BaseResponse<{Pension: RejectPension}>>(this.baseAPIUrl + `pensioners/pensiondetail`, msgData, this.httpOptions);
  }

  getPensionerByPPANo(ppaNumber: string) {
    const msgData = {
      PPANumber: ppaNumber
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_PENSIONER_BY_PPANO, msgData);

    return this.http.post<BaseResponse<{ Pensioners: PensionerByPPANo[] }>>(this.baseAPIUrl + `pensioners/searchbyppano`, msgData, this.httpOptions);
  }

  uploadPensionerFile(msgData: FormData) {
    const request = this.requestService.createBaseRequest(ConstantValues.UPLOAD_PENSIONER, null);
    msgData.append('MsgInfo.VersionNo', request.MsgInfo.VersionNo);
    msgData.append('MsgInfo.MsgID', request.MsgInfo.MsgID);
    msgData.append('MsgInfo.TimeStamp', request.MsgInfo.TimeStamp);
    msgData.append('MsgInfo.MsgType', request.MsgInfo.MsgType);
    msgData.append('MsgInfo.InsID', request.MsgInfo.InsID);
    msgData.append('HashValue', request.HashValue);

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `pensions/batchupload`, msgData, this.httpOptions);
  }

  downloadPensionerSampleExcelFile(): Observable<Blob> {
    return this.http.get(this.baseAPIUrl + 'pensioners/downloadsamplepensioner', { responseType: 'blob' });
  }

  getKYCandPDAttachment(msgData: any) {
    return this.http.post(this.baseAPIUrl + 'pensions/getportalattachment', msgData, this.httpOptions);
  }

  postKYCAndPDAttachment(msgData: any) {
    return this.http.post(this.baseAPIUrl + 'pensions/uploadmoreattachment', msgData, this.httpOptions);
  }

  requestOtp(payload: OtpRequest) {
    const msgData = payload

    const request = this.requestService.createBaseRequest(ConstantValues.GET_OTP, msgData);

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `paymeusers/requestotp`, msgData, this.httpOptions);
  }   
  verifyOtp(payload: OtpVerify) {
    const msgData = payload

    const request = this.requestService.createBaseRequest(ConstantValues.TWO_FACTOR_VERIFY, msgData);

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `paymeUsers/verifyotp`, request, this.httpOptions);
  }
}
